import React, { Component } from 'react';
import { connect } from 'react-redux';
import LazyLoad from 'react-lazyload';

import { toggle_navigation_menu } from '../../../actions/update_state';
import { update_calendar_data } from '../../../actions/update_data';

import Description from './MasterClassDescription';
import SignUp from './SignUpBtn';
import PupilsWork from './PupilsWork';
import Reviews from './Reviews';
// import Modal from './Modal';
import Map from './Map';
import SEO from '../../Common/SEO';

import './style.css';

let temp_pos = 0;

function scrollBy(distance, duration, y_pos) {
    let initialY = 0;
    if (y_pos !== undefined) {
        initialY = y_pos
    } else {
        initialY = temp_pos;
    }
    let y = initialY + distance;
    let baseY = (initialY + y) * 0.5;
    let difference = initialY - baseY;
    let startTime = performance.now();
    function step() {
        let normalizedTime = (performance.now() - startTime) / duration;
        if (normalizedTime > 1) normalizedTime = 1;
        window.scrollTo(0, baseY + difference * Math.cos(normalizedTime * Math.PI));
        if (normalizedTime < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
}

function scrollTo(link, to) {
    link.onclick = function(){
        if (to != null) {
            scrollBy(to.offsetTop-temp_pos-100, 500);
        }
    };
}

const switchColor = (pos, block, currentPos, nextPos) => {
    if (currentPos != null && nextPos !== null) {
        if (pos > currentPos.offsetTop-200 && pos < nextPos.offsetTop-200) {
            block.style.color = '#3C3C3C';
            block.style.borderBottom = '2px solid #f2cf32';
        } else {
            block.style.color = '';
            block.style.borderBottom = '';
        }
    } else if (currentPos != null && nextPos === null) {
        if (pos > currentPos.offsetTop-200) {
            block.style.color = '#3C3C3C';
            block.style.borderBottom = '2px solid #f2cf32';
        } else {
            block.style.color = '';
            block.style.borderBottom = '';
        }
    }
}

const switch_color_mob = (pos, block, currentPos, nextPos, menu, menuIndex) => {
    if (currentPos != null && nextPos !== null) {
        if (pos > currentPos.offsetTop-200 && pos < nextPos.offsetTop-200) {
            block.style.color = '#3C3C3C';
            block.style.backgroundColor = '#f2cf32';
            menu.value = menuIndex;
        } else {
            block.style.color = '#9B9B9B';
            block.style.backgroundColor = 'transparent';
        }
    } else if (currentPos != null && nextPos === null) {
        if (pos > currentPos.offsetTop-200) {
            block.style.color = '#3C3C3C';
            block.style.backgroundColor = '#f2cf32';
            menu.value = menuIndex;
        } else {
            block.style.color = '#9B9B9B';
            block.style.backgroundColor = 'transparent';
        }
    }
}

function compareDate(a, b) {
    if (+a.year === +b.year) {
        if (+a.month === +b.month) {
            if (+a.day > +b.day) return 1
            else return -1
        } else if (+a.month > +b.month) {
            return 1;
        } else if (+a.month < +b.month) {
            return -1;
        }
    } else if (+a.year > +b.year) {
        return 1;
    } else if (+a.year < +b.year) {
        return -1;
    }
}

class ArticlePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: ``,
            description: ``,
            seo_description: ``,
            main_image: null,
            gallery_arr: [],
            review_arr: [],
            fetch_calendar_data: [],
            calendar_data: [],
            map: null,
            price: '',
            modal_is_open: false,
            fade: true,
            is_listen: false,
            contact_text: ''
        }
    }

    /**
     * При загрузке компонента прокрутка кверху.
    //  */
    // UNSAFE_componentWillMount() {
    //     window.scrollTo(0, 0);
    // };

    /**
     * Операции:
     * 1) Обработка данных мастер-класса;
     * 2) Проявление страницы.
     */
    componentDidMount() {
        //прокрутка на 1пкс - для корректной работы меню
        window.scrollTo(0, 1);

        // вызов данных календаря
        fetch(this.props.url+'/wp-json/wp/v2/mc-calendar').then((response) => {
            if(!response.ok) {
                console.log("Что-то не так с тегами: " + response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((data) => {
            if (data.length > 0) {
                this.setState({
                    fetch_calendar_data: data
                })
            }
        })

        // обработка данных
        if (this.props.data !== undefined) {
            let content = this.props.data.content;
            if (this.state.description === '') {
                let temp_description_arr, new_description_arr = '', temp_price_arr, new_price_arr = '', review_arr, main_image_temp_arr, main_image_arr, main_image_new_arr, main_image;

                // разбивка на описание, для лучшей ориентации порядок разбивка сохраняет последовательность элементов на странице
                temp_description_arr = content.split('"description-text">');
                if (temp_description_arr.length > 1) {
                    temp_description_arr.shift();
                    // console.log(temp_description_arr);
                    new_description_arr = temp_description_arr[0].split('</p>');
                    new_description_arr = new_description_arr[0];
                }

                // разбивка на цену
                temp_price_arr = content.split('"price">');
                if (temp_price_arr.length > 1) {
                    temp_price_arr.shift();
                    new_price_arr = temp_price_arr[0].split('</p>');
                    new_price_arr = new_price_arr[0];
                }

                // разбивка на главное изображение
                main_image_temp_arr = content.split('main-image">');
                if (main_image_temp_arr.length > 1) {
                    main_image_arr = main_image_temp_arr[1];
                    main_image_new_arr = main_image_arr.split('</figure>');
                    main_image = main_image_new_arr[0];
                }

                let temp_gallery_arr = content.split(' gallery ');
                let to_state_arr = [];
                if (temp_gallery_arr.length > 1) {
                    temp_gallery_arr.shift();
                    for (let i = 0; i < temp_gallery_arr.length; i++) {
                        if (temp_gallery_arr[i].includes('gallery-inline">')) {
                            //здесь просто череда разбивки строки на массив (и обратно) и отрезание лишнего, чтобы получить строку с <img /> содержимым
                            let gallery_inline_temp_old = temp_gallery_arr[i].split('gallery-inline">')[1];
                            let gallery_inline_old_arr = gallery_inline_temp_old.split('</ul>')[0];
                            let gallery_inline_new_arr = gallery_inline_old_arr.split('<img ');
                            gallery_inline_new_arr.shift();
                            let gallery_inline_arr = gallery_inline_new_arr.map((item) => {
                                let temp_item = item.split('/>');
                                let new_item = temp_item[0];
                                return '<img '+new_item+'/>';
                            });
                            let gallery_obj = Object.create(null);
                            gallery_obj.type = 'inline';
                            gallery_obj.data = gallery_inline_arr;
                            to_state_arr.push(gallery_obj);
                        } else if (temp_gallery_arr[i].includes('gallery-left">')) {
                            //здесь просто череда разбивки строки на массив (и обратно) и отрезание лишнего, чтобы получить строку с <img /> содержимым
                            let gallery_left_temp_old = temp_gallery_arr[i].split('gallery-left">')[1];
                            let gallery_left_old_arr = gallery_left_temp_old.split('</ul>')[0];
                            let gallery_left_new_arr = gallery_left_old_arr.split('<img ');
                            gallery_left_new_arr.shift();
                            let gallery_left_arr = gallery_left_new_arr.map((item) => {
                                let temp_item = item.split('/>');
                                let new_item = temp_item[0];
                                return '<img '+new_item+'/>';
                            });
                            let gallery_obj = Object.create(null);
                            gallery_obj.type = 'left';
                            gallery_obj.main_image = gallery_left_arr[0];
                            gallery_left_arr.shift();
                            gallery_obj.data = gallery_left_arr;
                            to_state_arr.push(gallery_obj);
                        } else if (temp_gallery_arr[i].includes('gallery-right">')) {
                            //здесь просто череда разбивки строки на массив (и обратно) и отрезание лишнего, чтобы получить строку с <img /> содержимым
                            let gallery_right_temp_old = temp_gallery_arr[i].split('gallery-right">')[1];
                            let gallery_right_old_arr = gallery_right_temp_old.split('</ul>')[0];
                            let gallery_right_new_arr = gallery_right_old_arr.split('<img ');
                            gallery_right_new_arr.shift();
                            let gallery_right_arr = gallery_right_new_arr.map((item) => {
                                let temp_item = item.split('/>');
                                let new_item = temp_item[0];
                                return '<img '+new_item+'/>';
                            });
                            let gallery_obj = Object.create(null);
                            gallery_obj.type = 'right';
                            gallery_obj.main_image = gallery_right_arr[gallery_right_arr.length-1];
                            gallery_right_arr.pop();
                            gallery_obj.data = gallery_right_arr;
                            to_state_arr.push(gallery_obj);
                        }
                    }
                }

                // разбивка на отзывы
                review_arr = content.split('review">');
                review_arr.shift();
                let reviews = [];
                if (review_arr !== undefined && review_arr.length > 1) {
                    reviews = review_arr.map(function (review) {
                        //разбивка цельной строки на массив отдельныъ элементов с выделением строки <img /> комментария
                        let old_temp_arr, new_temp_arr, image;
                        old_temp_arr = review.split('<img ');
                        new_temp_arr = old_temp_arr[1].split('/>');
                        image = '<img '+new_temp_arr[0]+'/>';
                        //разбиваем остальной массив на текст комментария, выделенный текст и автора
                        let text_temp_arr, text_new_arr, format_text, text, highlight_new_arr, format_highlight, highlight, format_autor, autor_new_arr, autor;
                        text_temp_arr = new_temp_arr[1];
                        text_new_arr = text_temp_arr.split('text">');
                        text_new_arr.shift();
                        format_text = text_new_arr[0].split('</p>');
                        text = '<p>'+format_text[0]+'</p>';
                        highlight_new_arr = text_temp_arr.split('yellow-text">');
                        highlight_new_arr.shift();
                        format_highlight = highlight_new_arr[0].split('</p>');
                        highlight = '<p>'+format_highlight[0]+'</p>';
                        autor_new_arr = text_temp_arr.split('name">');
                        autor_new_arr.shift();
                        format_autor = autor_new_arr[0].split('</p>');
                        autor = '<p>'+format_autor[0]+'</p>';
                        return (
                            {
                            'image' : image,
                            'text' : text,
                            'highlight' : highlight,
                            'name' : autor
                            }
                        );
                    });
                }

                // разбивка на карту и текст
                let map_object = null,
                    map,
                    map_text;
                let page_map_temp_arr = content.split('description-map">');
                if (page_map_temp_arr.length > 1) {
                    map_object = Object.create(null);
                    page_map_temp_arr.shift();
                    let map_temp_arr = page_map_temp_arr[0].split('<iframe');
                    map_temp_arr.shift();
                    let map_arr = map_temp_arr[0].split('</iframe>');
                    map = '<iframe'+map_arr[0]+'</iframe>';
                    let text_temp_arr = page_map_temp_arr[0].split('map-text">');
                    let text_arr;
                    if(text_temp_arr.length > 1) {
                        text_temp_arr.shift();
                        text_arr = text_temp_arr[0].split('</p>');
                        map_text = text_arr[0];
                    } else {
                        map_text = ''; 
                    }
                    map_object.map = map;
                    map_object.text = map_text;
                }

                // передача обработанных данных в state
                this.setState({
                    title: this.props.data.title,
                    description: '<p class="description__text">'+new_description_arr+'</p>',
                    seo_description: new_description_arr.replace('<br/>', `
                    `),
                    price: new_price_arr,
                    main_image: main_image,
                    gallery_arr: to_state_arr,
                    review_arr: reviews,
                    map: map_object
                })
            }
        }

        // проявление страницы
        setTimeout(() => {
            this.setState({
                fade: false
            })
        }, 1000);

        setTimeout(() => {
            this.props.toggle_navigation_menu(true);
        }, 500);

        fetch(this.props.url+'wp-json/wp/v2/static-info/900').then((response) => {
            if(!response.ok) {
                console.log("Что-то не так со статическими данными: " + response.statusText);
            }
            else return response;
        })
        .then((response) => response.json())
        .then((data) => {
            if (data !== undefined && data !== null) {
                let contact_text = data.content.rendered;
                contact_text = contact_text.split('class="contact-data">')[1];
                contact_text = contact_text.split('</p>')[0];
                this.setState({
                    contact_text: contact_text
                })
            }
        })
    }

    /**
     * Операции:
     * 1) Работа верхнего меню (переключение вкладок, прокручивание к блокам и пр.).
     * 2) Появление верхнего меню;
     * 3) Обработка данных календаря для store;
     * 4) Обработка отформатированных данных для хранения в компоненте (для модального окна).
     */
    componentDidUpdate(prevProps) {
        let toDescDist = document.getElementById('description-dest');
        if (toDescDist !== null && this.state.is_listen === false) {
            //desktop
            let description = document.getElementById('description');
            let pupil_work = document.getElementById('pupil_work');
            let reviews = document.getElementById('reviews');
            let map = document.getElementById('map');
            let toPWDist = document.getElementById('pupil_work-dest');
            let toReviewsDist = document.getElementById('reviews-dest');
            let toMapDist = document.getElementById('map-dest');
            scrollTo(description, toDescDist);
            scrollTo(pupil_work, toPWDist);
            scrollTo(reviews, toReviewsDist);
            scrollTo(map, toMapDist);

            //mobile
            let nav_menu = document.getElementById('nav-menu');
            let description_mob = document.getElementById('description_mob');
            let pupil_work_mob = document.getElementById('pupil_work_mob');
            let reviews_mob = document.getElementById('reviews_mob');
            let map_mob = document.getElementById('map_mob');
            nav_menu.onchange = function(){
                let selectVal = nav_menu.options[nav_menu.selectedIndex].attributes.id.nodeValue;
                selectVal = selectVal.replace('_mob', '');
                let to = document.getElementById(selectVal+'-dest');
                if (to != null) {
                    scrollBy(to.offsetTop-temp_pos+20, 500);
                }
            };

            window.addEventListener('scroll', function() {
                temp_pos = window.pageYOffset;
                switchColor(temp_pos, description, toDescDist, toPWDist);
                switchColor(temp_pos, pupil_work, toPWDist, toReviewsDist);
                switchColor(temp_pos, reviews, toReviewsDist, toMapDist);
                switch_color_mob(temp_pos, description_mob, toDescDist, toPWDist, nav_menu, 'Описание');
                switch_color_mob(temp_pos, pupil_work_mob, toPWDist, toReviewsDist, nav_menu, 'Работы учеников');
                switch_color_mob(temp_pos, reviews_mob, toReviewsDist, toMapDist, nav_menu, 'Отзывы');
                if (toReviewsDist != null && toMapDist !== null) {
                    if (temp_pos > toMapDist.offsetTop-200) {
                        map.style.color = '#3C3C3C';
                        map.style.borderBottom = '2px solid #f2cf32';
                    } else {
                        map.style.color = '';
                        map.style.borderBottom = '';
                    }
                }
                if (toMapDist != null && toMapDist !== null) {
                    if (temp_pos > toMapDist.offsetTop-200 && temp_pos > toDescDist.offsetTop-200) {
                        map_mob.style.color = '#3C3C3C';
                        map_mob.style.backgroundColor = '#f2cf32';
                        nav_menu.value = 'Карта';
                    } else {
                        map_mob.style.color = '#9B9B9B';
                        map_mob.style.backgroundColor = 'transparent';
                    }
                }
            });

            this.setState({
                is_listen: true
            })
        }

        if (this.props.updated_calendar_data === null && this.state.fetch_calendar_data.length !== 0) {
            // let day = '', month = '', year = '';
            let updated_arr = [];
            for (let i = 0; i < this.state.fetch_calendar_data.length; i++) {
                //видоизменяем данные с сервера, чтобы с ними было удобно работать
                let item = this.state.fetch_calendar_data[i];
                let temp_arr_item = {
                    name: '',
                    time: '',
                    price: '',
                    date: '',
                    day: '',
                    month: '',
                    year: '',
                    categories: [],
                    link: '',
                    image: '',
                    seats: ''
                }
                temp_arr_item.name = item.title.rendered;

                let price = item.content.rendered.split('class="calendar-price">');
                price = price[1];
                if (price !== undefined) {
                    price = price.split('</p>');
                    temp_arr_item.price = price[0];
                }

                let link = item.content.rendered.split('class="calendar-link">');
                link = link[1];
                if (link !== undefined) {
                    link = link.split('</p>');
                    temp_arr_item.link = link[0];
                }

                let image = item.content.rendered.split('calendar-image"><img ');
                image = image[1];
                if (image !== undefined) {
                    image = image.split(' />');
                    temp_arr_item.image = '<img '+image[0]+' />';
                }
 
                //добавление категорий
                if (item.categories.length > 0) {
                    for (let l = 0; l < item.categories.length; l++) {
                        temp_arr_item.categories.push(item.categories[l]);
                    }
                }

                let date = item.content.rendered.split('class="calendar-date">'),
                    date_arr = [];
                date = date[1];
                if (date !== undefined) {
                    date = date.split('</p>');
                    date = date[0];
                    temp_arr_item.date = date;

                    let temp_new_arr = date.split('<br>');

                    temp_new_arr.forEach(item => {
                        let temp_new_arr_item = Object.create(null);
                        let date_split = item.split(', ');
                        let new_temp_arr = date_split[0].split('.');
                        temp_new_arr_item.name = temp_arr_item.name;
                        temp_new_arr_item.price = temp_arr_item.price;
                        temp_new_arr_item.date = date_split[0];
                        temp_new_arr_item.categories = temp_arr_item.categories;
                        temp_new_arr_item.link = temp_arr_item.link;
                        temp_new_arr_item.image = temp_arr_item.image;
                        temp_new_arr_item.day = new_temp_arr[0];
                        temp_new_arr_item.month = new_temp_arr[1];
                        temp_new_arr_item.year = new_temp_arr[2];
                        temp_new_arr_item.time = date_split[1];
                        if (date_split[2] !== undefined && date_split[2] === '&#8212;') temp_new_arr_item.seats = '-';
                        else temp_new_arr_item.seats = date_split[2];
                        date_arr.push(temp_new_arr_item);   //сюда отправляем чтобы потом корректно отображать данные
                        updated_arr.push(temp_new_arr_item);
                    })
                }
            }
            updated_arr.sort(compareDate);
            this.props.update_calendar_data(updated_arr);
        }

        if (this.props.updated_calendar_data !== null && this.state.calendar_data.length === 0) {
            let temp_arr = [];
            let link = window.location.href;
            link = link.split('/');
            if ('/'+decodeURIComponent(link[link.length-1]) === '/') link = '/'+decodeURIComponent(link[link.length-2]);
            else link = '/'+decodeURIComponent(link[link.length-1]);
            
            let date = new Date();
            let day = date.getDate();
            let month = date.getMonth()+1;
            for (let i = 0; i < this.props.updated_calendar_data.length; i++) {
                if (this.props.updated_calendar_data[i].link === link) {
                    if (+month >= +this.props.updated_calendar_data[i].month && +day > +this.props.updated_calendar_data[i].day) {
                        // пустой блок, который ничего не делает, но при этом забирает часть ответа (чтобы старые даты не попадали в массив)
                    } else {
                        let month_name = '';
                        switch (+this.props.updated_calendar_data[i].month) {
                            case (1):
                                month_name = 'января';
                                break;
                            case (2):
                                month_name = 'февраля';
                                break;
                            case (3):
                                month_name = 'марта';
                                break;
                            case (4):
                                month_name = 'апреля';
                                break;
                            case (5):
                                month_name = 'мая';
                                break;
                            case (6):
                                month_name = 'июня';
                                break;
                            case (7):
                                month_name = 'июля';
                                break;
                            case (8):
                                month_name = 'августа';
                                break;
                            case (9):
                                month_name = 'сентября';
                                break;
                            case (10):
                                month_name = 'октября';
                                break;
                            case (11):
                                month_name = 'ноября';
                                break;
                            case (12):
                                month_name = 'декабря';
                                break;
                            default:
                                break;
                        }
                        let return_text = '';
                        if (this.props.updated_calendar_data[i].time !== undefined && this.props.updated_calendar_data[i].seats !== '-') {
                            return_text = this.props.updated_calendar_data[i].day+" "+month_name+", "+this.props.updated_calendar_data[i].time;
                        } else if (this.props.updated_calendar_data[i].time !== undefined && this.props.updated_calendar_data[i].seats === '-') {
                            return_text = this.props.updated_calendar_data[i].day+" "+month_name+", "+this.props.updated_calendar_data[i].time+' (мест нет)';
                        } else {
                            return_text = this.props.updated_calendar_data[i].day+" "+month_name;
                        }
                        temp_arr.push(return_text);
                    }
                }
            }
            temp_arr = [...new Set(temp_arr)]; //добавление в коллекцию сразу убирает дублированные значения
            if (temp_arr.length > 0) {
                this.setState({
                    calendar_data: temp_arr
                })
            }
        }

        if (this.state.modal_is_open === true) {
            let body = document.getElementsByTagName('body')[0];
            body.style.overflowY = 'hidden';
        } else {
            let body = document.getElementsByTagName('body')[0];
            body.style.overflowY = '';
        }
    }

    /**
     * Отправка в store стандартных значений для корректной работы.
     */
    componentWillUnmount() {
        this.props.toggle_navigation_menu(false);
    }

    /**
     * Прокрутка к форме
     */
    _to_form_click = () => {
        let temp_var = window.pageYOffset,
            window_width = window.innerWidth,
            form = document.getElementsByClassName('form-container')[0];

        //для мобильной версии другая форма
        if (window_width < 991) form = document.getElementsByClassName('form-container')[1];
        
        if (form != null) scrollBy(form.offsetTop-70-temp_var, 500);
    }
    
    render (){
        return(
            <main className="lg-container">
                <SEO title={this.state.title}
                    description={this.state.seo_description !== '' ? this.state.seo_description : 'Студия керамики в Минске!'}
                    url={'/mc/'+this.props.data.slug} />
                <section className={this.state.fade ? 'master-class' : 'master-class fadeIn'}>
                    <Description
                        description={this.state.description}
                        image={this.state.main_image}
                        name={this.state.title} header={this.state.title}
                        calendar={this.state.calendar_data}
                        date={this.props.date}
                        price={this.state.price} />
                    {
                        this.state.gallery_arr.length === 0 ? null :
                        <div id="pupil_work-dest">
                            <PupilsWork gallery_arr={this.state.gallery_arr} />
                            <SignUp click={this._to_form_click} />
                        </div>
                    }
                    {
                        this.state.review_arr.length < 2 ?  null :
                        <div id="reviews-dest">
                            <LazyLoad height={1000} once offset={100}>
                                <Reviews reviews={this.state.review_arr} />
                                <div className="reviews__insta-link_container">
                                    <a className="reviews__insta-link" href="https://www.instagram.com/moonceramic/" target="_blank" rel="noopener noreferrer">Больше отзывов — в Инстаграме @moonceramic</a>
                                </div>
                                <SignUp click={this._to_form_click} />
                            </LazyLoad> 
                        </div>
                    }
                    <div id="map-dest">
                        <LazyLoad height={1000} once offset={100}>
                            <Map text={this.state.contact_text} />
                            <SignUp click={this._to_form_click} />
                        </LazyLoad>
                    </div>
                    {/* {
                        this.state.modal_is_open ? 
                        <Modal header={this.state.title}
                            calendar={this.state.calendar_data}
                            click={this._to_form_click}
                            date={this.props.date} /> 
                        : null
                    } */}
                </section>
            </main>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        url: state.site_options.SITE_URL,
        updated_calendar_data: state.updated_calendar_data
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggle_navigation_menu: (bool) => dispatch(toggle_navigation_menu(bool)),
        update_calendar_data: (data) => dispatch(update_calendar_data(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticlePage);